import React from 'react';
import {
  required,
  Create,
  SimpleForm,
  TranslatableInputs,
  TextInput,
  ReferenceInput,
  SelectInput,
  NumberInput,
  ReferenceArrayInput,
  AutocompleteArrayInput
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';

// own ui
import RichTextInput from '../../ui/rich-text-input';

export const styles =
{
  inlineWidth: { width: '20em' },
  inlineFormGroup: { display: 'inline-block', marginRight: 20 }
};

const useStyles = makeStyles(styles);
const validateSubCategoryAttractive = required('Selecione uma sub categoria!');
const validateSubTheme = required('Selecione um sub tema!');
const validateName = [required('Digite o nome!')];
const validateDescription = [required('Digite a descrição!')];
const validateAddress = [required('Digite o endereço!')];
const validateLat = [required('Digite a latitude!')];
const validateLng = [required('Digite a longitude!')];
const validateImages = [required('Selecione pelo menos 1 imagem!')];
const validateCities = [required('Selecione pelo menos 1 cidade!')];
const optionRendererSubCategoryAttractive = sub_category_attractive => `${sub_category_attractive.category_attractive_name} - ${sub_category_attractive.name.pt_br}`;
const optionRendererSubTheme = sub_theme => `${sub_theme.theme_name} - ${sub_theme.name.pt_br}`;
const optionRendererSubCategoryTerroirs = sub_category_terroirs => `${sub_category_terroirs.category_terroirs_name} - ${sub_category_terroirs.name.pt_br}`;

const AttractiveCreate = (props) => {
  const classes = useStyles();

  return (
  <Create title="Novo Atrativo" {...props}>
    <SimpleForm redirect="/attractive">
      <ReferenceInput source="sub_category_attractive_id" sort={{ field: 'name_pt_br', order: 'asc' }} label="Sub Categoria" fullWidth={true} reference="sub-category-attractive" validate={validateSubCategoryAttractive} >
        <SelectInput optionText={optionRendererSubCategoryAttractive} optionValue="id" />
      </ReferenceInput>
      <ReferenceInput source="sub_theme_id" sort={{ field: 'name_pt_br', order: 'asc' }} label="Sub Tema" fullWidth={true} reference="sub-theme" validate={validateSubTheme} >
        <SelectInput optionText={optionRendererSubTheme} optionValue="id" />
      </ReferenceInput>
      <TranslatableInputs locales={['pt_br', 'en_us']} defaultLocale="pt_br">
        <TextInput source="name" label="Nome" fullWidth={true} validate={validateName} />
        <RichTextInput source="description" label="Descrição" validate={validateDescription} />
        <RichTextInput source="address" label="Endereço" validate={validateAddress} />
      </TranslatableInputs>
      <NumberInput source="lat" label="Latitude" className={classes.inlineWidth} formClassName={classes.inlineFormGroup} validate={validateLat} />
      <NumberInput source="lng" label="Longitude" className={classes.inlineWidth} formClassName={classes.inlineFormGroup} validate={validateLng} />
      <ReferenceArrayInput label="Imagens" source="images" fullWidth={true} reference="image" validate={validateImages}>
        <AutocompleteArrayInput limitChoicesToValue={true} shouldRenderSuggestions={(val) => { return val ? val.trim().length > 2 : false }} optionText="name" optionValue="id" />
      </ReferenceArrayInput>
      <ReferenceArrayInput label="Cidade(s)" source="cities" fullWidth={true} reference="setup/cities/with/detail" validate={validateCities}>
        <AutocompleteArrayInput optionText="name" optionValue="id" limitChoicesToValue={true} shouldRenderSuggestions={(val) => { return val ? val.trim().length > 2 : false }} />
      </ReferenceArrayInput>
      <ReferenceInput label="Sub Categoria Terroirs" sort={{ field: 'name_pt_br', order: 'asc' }} allowEmpty source="sub_category_terroirs_id" fullWidth={true} reference="sub-category-terroirs">
        <SelectInput optionText={optionRendererSubCategoryTerroirs} optionValue="id" />
      </ReferenceInput>
    </SimpleForm>
  </Create>
)};

export default AttractiveCreate;
